import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import LeadingWoman from "./interactiveAds/standardBank/LeadingWoman";
import SheisPriceless from "./interactiveAds/mastercard/SheisPriceless";
import SheisPriceless2 from "./interactiveAds/2025/mastercard/SheisPriceless";
import TopEmployer from "./interactiveAds/topEmployer/TopEmployer";

const router = createBrowserRouter([
  {
    path: "/",
    element: <div>Hello world!</div>,
  },
  {
    path: "/standard-bank-woman-in-tech",
    element: <LeadingWoman />,
  },
  {
    path: "/mastercard-she-is-priceless",
    element: <SheisPriceless />,
  },
  {
    path: "/mastercard-she-is-priceless-2025",
    element: <SheisPriceless2 />,
  },
  {
    path: "/top-employer",
    element: <TopEmployer />,
  }


]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
